<template>
  <b-modal
    id="modal-scoped"
    ref="modal-scoped"
    title="Recuperação de senha"
    no-close-on-backdrop
    hide-footer
    :visible="showModalRecoverPassword"
    cancel-disabled
    centered
    size="md"
    @close="closeModal"
    @hide="closeModal"
    data-cy="modal-recuperar-senha-principal"
  >
    <template>
      <fieldset :disabled="loading" data-cy="fieldset-recuperar-senha">
        <form
          @submit.stop.prevent="submit()"
          class="needs-validation"
          data-cy="form-recuperar-senha"
        >
          <div class="card p-3" data-cy="card-recuperar-senha">
            <div
              class="d-flex flex-column align-items-center w-100 mb-2"
              data-cy="header-recuperar-senha"
            >
              <h5
                class="font-weight-bold mb-0"
                data-cy="titulo-recuperar-senha"
              >
                Digite seu e-mail:
              </h5>
            </div>
            <div class="form-group" data-cy="campo-email-form-group">
              <b-form-input
                required
                type="email"
                class="form-control rounded-0"
                id="email"
                name="email"
                placeholder="E-mail"
                v-model="form.email"
                :state="validation.email"
                data-cy="campo-email-input"
              />
              <div class="invalid-feedback" data-cy="campo-email-erro">
                Digite um e-mail válido. Ex: joao@quark.com.br
              </div>
            </div>
            <div
              class="d-flex flex-row justify-content-center"
              data-cy="container-btn-recuperar"
            >
              <button
                type="button"
                class="btn btn-md text-nowrap btn p-3 d-block w-100"
                style="background-color: #29b891; color: white;"
                @click="submit()"
                data-cy="btn-recuperar-senha"
              >
                <font-awesome-icon
                  v-if="loading"
                  spin
                  :icon="['fas', 'circle-notch']"
                  data-cy="loading-icon"
                >
                </font-awesome-icon>
                Recuperar senha
              </button>
            </div>
          </div>
        </form>
      </fieldset>
    </template>
  </b-modal>
</template>

<script>
import { mask } from "vue-the-mask";
import { axiosInstance as Axios } from "@/main";
import { validEmail } from "@/core/enumHelper";

export default {
  name: "modal-user-recuperar-senha",
  directives: {
    mask
  },
  computed: {
    showModalRecoverPassword() {
      return this.$store.getters.show_modalRecoverPassword;
    },
    actual() {
      return this.$store.getters.actual;
    },
    go() {
      return this.$store.getters.to;
    },
    user() {
      return this.$store.getters.user;
    },
    to() {
      return this.$store.getters.to;
    },
    urls() {
      return this.$store.getters.urls;
    }
  },
  data() {
    return {
      loading: false,
      validation: {
        email: null
      },
      form: {
        email: null
      }
    };
  },
  methods: {
    submit: async function() {
      this.loading = true;
      if (
        this.form.email === "" ||
        this.form.email === null ||
        !validEmail(this.form.email)
      ) {
        this.validation.email = false;
        this.loading = false;
        return;
      } else {
        this.validation.email = true;
      }

      let payload = {
        url: `${this.$serverHost}auth/solicitar-recuperacao`,
        email: this.form.email
      };

      try {
        this.loading = true;
        await Axios.post(`${payload.url}?email=${payload.email}`, "");
        const mensagem =
          "Se houver um usuário com o e-mail informado, você irá receber um link no e-mail para realizar a troca de senha";
        this.$bvToast.toast(mensagem, {
          title: "Sucesso",
          variant: "success",
          autoHideDelay: 10000,
          appendToast: true
        });
      } catch (e) {
        console.log(e.response);
        return;
      } finally {
        this.loading = false;
      }
      this.$router.push(this.to);
    },
    closeModal() {
      this.email = null;
      this.$store.dispatch("set_modalRecoverPassword", false);
    }
  }
};
</script>

<style scoped></style>
